<template>
  <div class="this-container candidate-detail-page">
    <div class="list-container">
      <el-row class="detail-actions mb20">
        <el-button @click="$router.back()">返回</el-button>
        <el-button type="primary" @click="exportPdf">导出PDF打印</el-button>
<!--        <el-button type="success" @click="exportWord">导出Word</el-button>-->
      </el-row>

      <div v-loading="loading" class="paper-wrap">
        <div ref="paperRef" class="recommend-paper">
          <header class="paper-header">
            <div class="association-line">
              <span>山东省心理咨询行业协会</span>
              <span class="committee-line">{{ detail.committee || '' }}</span>
            </div>
            <h1>委员候选人推荐表</h1>
            <div class="serial-row">
              <span class="serial-label">编号：</span>
              <span class="serial-no">{{ detail.serial_no || '' }}</span>
            </div>
          </header>

          <table class="recommend-table">
            <tbody>
              <tr>
                <th>姓名</th>
                <td>{{ detail.name }}</td>
                <th>性别</th>
                <td>{{ detail.gender }}</td>
                <th>出生年月</th>
                <td>{{ detail.birthday }}</td>
                <td rowspan="5" class="photo-cell">
                  <img v-if="detail.photo" :src="detail.photo" alt="照片">
                  <span v-else>（贴照片处）</span>
                </td>
              </tr>
              <tr>
                <th>籍贯</th>
                <td>{{ detail.native_place }}</td>
                <th>民族</th>
                <td>{{ detail.nation }}</td>
                <th>身份证号</th>
                <td>{{ detail.id_number }}</td>
              </tr>
              <tr>
                <th>入会时间</th>
                <td colspan="3">{{ detail.join_date }}</td>
                <th>会员证号</th>
                <td>{{ detail.member_no }}</td>
              </tr>
              <tr>
                <th>工作单位</th>
                <td colspan="3">{{ detail.company }}</td>
                <th>技术职称</th>
                <td>{{ detail.title }}</td>
              </tr>
              <tr>
                <th>联系地址</th>
                <td colspan="3">{{ detail.address }}</td>
                <th>邮编</th>
                <td>{{ detail.postal_code }}</td>
              </tr>
              <tr>
                <th>通讯方式</th>
                <td colspan="2">手机：{{ detail.mobile }}</td>
                <td colspan="2">办公：{{ detail.office_phone }}</td>
                <td colspan="2">Email：{{ detail.email }}</td>
              </tr>

              <tr>
                <th rowspan="4" class="vertical-title"><span>主要学历</span></th>
                <th colspan="2">起止年月</th>
                <th colspan="2">院校名称</th>
                <th colspan="2">学位</th>
              </tr>
              <tr v-for="(item, index) in fillRows(detail.education_list || detail.educationList, 3)" :key="'edu-' + index">
                <td colspan="2">{{ item.period }}</td>
                <td colspan="2">{{ item.school }}</td>
                <td colspan="2">{{ item.degree }}</td>
              </tr>

              <tr>
                <th rowspan="4" class="vertical-title"><span>主要工作经历</span></th>
                <th colspan="2">起止年月</th>
                <th colspan="2">工作单位</th>
                <th colspan="2">职务和技术职称</th>
              </tr>
              <tr v-for="(item, index) in fillRows(detail.work_list || detail.workList, 3)" :key="'work-' + index">
                <td colspan="2">{{ item.period }}</td>
                <td colspan="2">{{ item.company }}</td>
                <td colspan="2">{{ item.position }}</td>
              </tr>

              <tr>
                <th rowspan="5" class="vertical-title"><span>主要培训经历</span></th>
                <th colspan="2">起止时间</th>
                <th colspan="2">培训项目/课程名称</th>
                <th colspan="2">是否为注册系统认证课程</th>
              </tr>
              <tr v-for="(item, index) in fillRows(detail.training_list || detail.trainingList, 4)" :key="'training-' + index">
                <td colspan="2">{{ item.period }}</td>
                <td colspan="2">{{ item.course }}</td>
                <td colspan="2">是 {{ isCertified(item) ? '✓' : '' }}  否 {{ isCertified(item) === false ? '✓' : '' }}</td>
              </tr>

              <tr>
                <th colspan="2">其他社会兼职</th>
                <td colspan="3">{{ detail.part_time_job }}</td>
                <th>掌握外语情况</th>
                <td>{{ detail.foreign_language }}</td>
              </tr>
              <tr>
                <th colspan="3">单位意见</th>
                <th colspan="4">山东省心理咨询行业协会意见</th>
              </tr>
              <tr>
                <td colspan="3" class="opinion-cell">
                  <div>{{ detail.unit_opinion }}</div>
                  <div class="stamp">单位盖章：</div>
                  <div class="date-line">年  月  日</div>
                </td>
                <td colspan="4" class="opinion-cell">
                  <div>{{ detail.association_opinion || detail.audit_remark }}</div>
                  <div class="stamp">协会盖章：</div>
                  <div class="date-line">年  月  日</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="paper-footer">
            <p>说明:请务必正确填写会员证号码。复印件无效。</p>
            <p>我郑重承诺：本人所提供的个人信息真实、准确。本人签字：________________________</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import candidateRecommend from '@/api/candidateRecommend';

export default {
  name: 'UserCandidateRecommendDetail',
  data() {
    return {
      loading: false,
      detail: {}
    }
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.loading = true;
      const id = this.$route.query.id || this.$route.params.id;
      const res = await candidateRecommend.getDetail({ id });
      if (res) {
        this.detail = res.data || {};
      }
      this.loading = false;
    },
    fillRows(rows, min) {
      const list = Array.isArray(rows) ? rows.slice() : [];
      while (list.length < min) {
        list.push({});
      }
      return list;
    },
    isCertified(item) {
      if (!item || item.certified === undefined || item.certified === null || item.certified === '') return null;
      return item.certified === 1 || item.certified === '1' || item.certified === '是';
    },
    exportPdf() {
      const win = window.open('', '_blank');
      if (!win) return;
      win.document.write(`
        <html>
          <head><meta charset="utf-8"><title>委员候选人推荐表</title>${this.exportStyle()}</head>
          <body>${this.$refs.paperRef.outerHTML}</body>
        </html>
      `);
      win.document.close();
      win.focus();
      setTimeout(() => {
        win.print();
      }, 300);
    },
    exportWord() {
      const wordContent = this.buildWordContent();
      const html = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
          <head>
            <meta charset="utf-8">
            <title>委员候选人推荐表</title>
            <!--[if gte mso 9]>
            <xml>
              <w:WordDocument>
                <w:View>Print</w:View>
                <w:Zoom>100</w:Zoom>
                <w:DoNotOptimizeForBrowser/>
              </w:WordDocument>
            </xml>
            <![endif]-->
            ${this.wordPageStyle()}
          </head>
          <body>
            <div class="WordSection1">
              <table class="word-page-table" align="center" width="527" cellspacing="0" cellpadding="0" border="0" style="width:527pt;border-collapse:collapse;margin:0 auto;table-layout:fixed;">
                <tr>
                  <td width="527" style="width:527pt;padding:0;margin:0;vertical-align:top;">
                    ${wordContent}
                  </td>
                </tr>
              </table>
            </div>
          </body>
        </html>
      `;
      const blob = new Blob(['\ufeff', html], { type: 'application/msword' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.detail.name || '委员候选人'}推荐表.doc`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    buildWordContent() {
      const paper = this.$refs.paperRef.cloneNode(true);

      paper.setAttribute('style', 'width:527pt;max-width:527pt;margin:0 auto;padding:0;color:#000;font-family:SimSun,宋体,serif;');

      const header = paper.querySelector('.paper-header');
      if (header) {
        header.setAttribute('style', 'text-align:center;margin:0 0 4pt 0;padding:0;');
      }

      const associationLine = paper.querySelector('.association-line');
      if (associationLine) {
        associationLine.setAttribute('style', 'font-size:16pt;font-weight:bold;line-height:1.25;text-align:center;margin:0;padding:0;');
      }

      const committeeLine = paper.querySelector('.committee-line');
      if (committeeLine) {
        committeeLine.setAttribute('style', 'display:inline-block;min-width:112pt;margin-left:10pt;padding:0 4pt 1pt 4pt;border-bottom:1px solid #000;');
      }

      const title = paper.querySelector('.paper-header h1');
      if (title) {
        title.setAttribute('style', 'font-size:18pt;font-weight:bold;line-height:1.2;text-align:center;margin:2pt 0 2pt 0;padding:0;');
      }

      const serialRow = paper.querySelector('.serial-row');
      if (serialRow) {
        serialRow.setAttribute('style', 'font-size:10.5pt;line-height:1.2;text-align:right;margin:0 0 3pt 0;padding:0;');
      }

      const serialNo = paper.querySelector('.serial-no');
      if (serialNo) {
        serialNo.setAttribute('style', 'display:inline-block;width:120pt;border-bottom:1px solid #000;text-align:left;word-break:break-all;');
      }

      const table = paper.querySelector('.recommend-table');
      if (table) {
        table.setAttribute('width', '527');
        table.setAttribute('cellspacing', '0');
        table.setAttribute('cellpadding', '0');
        table.setAttribute('style', 'width:527pt;border-collapse:collapse;table-layout:fixed;font-size:11pt;mso-table-layout-alt:fixed;');
      }

      paper.querySelectorAll('.recommend-table th,.recommend-table td').forEach(cell => {
        cell.setAttribute('style', 'border:1px solid #000;height:24pt;padding:1.5pt 4pt;font-weight:normal;vertical-align:middle;word-break:break-all;overflow-wrap:anywhere;white-space:normal;');
      });

      paper.querySelectorAll('.vertical-title').forEach(cell => {
        cell.setAttribute('style', 'width:24pt;border:1px solid #000;padding:0;text-align:center;vertical-align:middle;');
      });

      paper.querySelectorAll('.vertical-title span').forEach(item => {
        item.setAttribute('style', 'display:inline-block;writing-mode:vertical-rl;white-space:nowrap;word-break:keep-all;overflow-wrap:normal;letter-spacing:0;text-align:center;');
      });

      paper.querySelectorAll('.photo-cell').forEach(cell => {
        cell.setAttribute('style', 'width:96pt;border:1px solid #000;text-align:center;vertical-align:middle;padding:0;');
      });

      paper.querySelectorAll('.photo-cell img').forEach(img => {
        img.setAttribute('width', '96');
        img.setAttribute('height', '130');
        img.setAttribute('style', 'width:96pt;height:130pt;display:block;margin:0 auto;');
      });

      paper.querySelectorAll('.opinion-cell').forEach(cell => {
        cell.style.height = '76pt';
        cell.style.verticalAlign = 'bottom';
      });

      const footer = paper.querySelector('.paper-footer');
      if (footer) {
        footer.setAttribute('style', 'font-size:11pt;line-height:1.5;margin-top:4pt;');
      }

      return paper.outerHTML;
    },
    exportStyle() {
      return `<style>
        @page WordSection1{size:210mm 297mm;margin:12mm 10mm 12mm 10mm} @page{size:A4 portrait;margin:12mm 10mm}*{box-sizing:border-box}html,body{margin:0;padding:0}body{font-family:"SimSun","宋体",serif;color:#000}.recommend-paper{width:186mm;max-width:186mm;margin:0 auto;padding:0}.paper-header{text-align:center;margin-bottom:6px}.association-line{font-size:21px;font-weight:700;line-height:1.35;white-space:normal}.committee-line{display:inline-block;min-width:150px;margin-left:14px;padding:0 6px 2px;border-bottom:1px solid #000}.paper-header h1{font-size:22px;margin:3px 0}.serial-row{text-align:right;font-size:14px;line-height:1.25}.serial-label{display:inline-block;width:42px;text-align:right}.serial-no{display:inline-block;max-width:48mm;min-width:42mm;text-align:left;border-bottom:1px solid #000;word-break:break-all;overflow-wrap:anywhere}.recommend-table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:15px}.recommend-table th,.recommend-table td{border:1px solid #000;height:32px;padding:2px 6px;font-weight:400;vertical-align:middle;word-break:break-all;overflow-wrap:anywhere;white-space:normal}.vertical-title{position:relative;width:32px;padding:0;text-align:center}.vertical-title span{position:absolute;top:50%;left:50%;display:block;writing-mode:vertical-rl;letter-spacing:0;text-align:center;white-space:nowrap;word-break:keep-all;overflow-wrap:normal;transform:translate(-50%,-50%)}.photo-cell{text-align:center;width:34mm}.photo-cell img{width:28mm;height:38mm;object-fit:cover}.textarea-cell{height:72px;white-space:pre-wrap}.opinion-cell{height:102px;vertical-align:bottom}.stamp{text-align:center;margin-top:40px}.date-line{text-align:center;margin-top:14px}.paper-footer{font-size:15px;line-height:1.6}thead{display:table-header-group}tr{page-break-inside:avoid}
      </style>`;
    },
    wordPageStyle() {
      return `
        <style>
          @page WordSection1 {
            size: 595.3pt 841.9pt;
            margin: 34pt 28.35pt 34pt 28.35pt;
            mso-page-orientation: portrait;
          }
          html, body {
            margin: 0;
            padding: 0;
            font-family: SimSun, 宋体, serif;
          }
          body {
            mso-page: WordSection1;
          }
          div.WordSection1 {
            page: WordSection1;
            width: 527pt;
            margin: 0 auto;
          }
          table.word-page-table {
            width: 527pt !important;
            max-width: 527pt !important;
            margin-left: auto;
            margin-right: auto;
            table-layout: fixed;
          }
        </style>
      `;
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-detail-page {
  .detail-actions {
    justify-content: flex-end;
  }

  .paper-wrap {
    overflow-x: auto;
    background: #f5f7fa;
    padding: 24px;
  }

  .recommend-paper {
    width: 774px;
    margin: 0 auto;
    padding: 42px 28px 28px;
    background: #fff;
    color: #000;
    font-family: "SimSun", "宋体", serif;
  }

  .paper-header {
    margin-bottom: 8px;
    text-align: center;

    .association-line {
      font-size: 24px;
      font-weight: 700;
      line-height: 1.45;
      white-space: normal;
    }

    .committee-line {
      display: inline-block;
      min-width: 180px;
      margin-left: 18px;
      padding: 0 8px 2px;
      border-bottom: 1px solid #000;
    }

    h1 {
      margin: 4px 0 0;
      font-size: 24px;
      font-weight: 700;
    }

    .serial-row {
      text-align: right;
      font-size: 16px;
      line-height: 1.3;
    }

    .serial-label {
      display: inline-block;
      width: 48px;
      text-align: right;
    }

    .serial-no {
      display: inline-block;
      min-width: 170px;
      text-align: left;
      border-bottom: 1px solid #000;
      word-break: break-all;
    }
  }

  .recommend-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 18px;

    th,
    td {
      height: 40px;
      padding: 0 8px;
      border: 1px solid #000;
      vertical-align: middle;
      font-weight: 400;
      word-break: break-all;
      overflow-wrap: anywhere;
      white-space: normal;
    }

    .vertical-title {
      position: relative;
      width: 42px;
      padding: 0;
      line-height: 1.45;
      letter-spacing: 0;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        writing-mode: vertical-rl;
        transform: translate(-50%, -50%);
        white-space: nowrap;
        word-break: keep-all;
        overflow-wrap: normal;
      }
    }

    .photo-cell {
      width: 136px;
      text-align: center;

      img {
        width: 100%;
        height: 180px;
        object-fit: cover;
      }
    }

    .textarea-cell {
      height: 90px;
      white-space: pre-wrap;
    }

    .opinion-cell {
      height: 130px;
      vertical-align: bottom;

      .stamp {
        margin-top: 54px;
        text-align: center;
      }

      .date-line {
        margin-top: 20px;
        text-align: center;
      }
    }
  }

  .paper-footer {
    font-size: 18px;
    line-height: 1.9;
  }
}

</style>

